import { render, staticRenderFns } from "./VPage.vue?vue&type=template&id=3ebd9cda&scoped=true"
import script from "./VPage.vue?vue&type=script&lang=js"
export * from "./VPage.vue?vue&type=script&lang=js"
import style0 from "./VPage.vue?vue&type=style&index=0&id=3ebd9cda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebd9cda",
  null
  
)

export default component.exports